export const getDurationinHrs = (val) => {
  if (typeof val !== "number" || isNaN(val) || val < 0) return "0m";
  const hours = Math.floor(val / 60);
  const minutes = val % 60;
  if (hours === 0) return `${minutes}m`;
  if (minutes === 0) return `${hours}h`;
  return `${hours}h ${minutes}m`;
};
